import { schema } from '@wix/da-shared-react/pkg/redux/normalizr';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';

export const GroupAdminsModuleDataResultSchema = new schema.Object({
  user: userSchema,
});
export const GroupAdminsModuleDataResultsSchema = [
  GroupAdminsModuleDataResultSchema,
];
